import {RouterModule, Routes}        from '@angular/router';
import {AuthenticationService}       from '../shared/authentication.service';
import {CanDo}                       from '../shared/CanDo';
import {Permission}                  from '../shared/api/permissions/api.models';
import {ProfilesPerGeoComponent}     from './profilesPerGeo/profilesPerGeo.component';
import {MessagecentralsResolver}     from '../shared/resolvers/messagecentrals.resolver';
import {ProfilesPerIpLevelComponent} from './profilesPerIpLevel/profilesPerIpLevel.component';
import {BasesResolver}               from '../shared/resolvers/bases.resolver';
import {Base}                        from '../shared/api/bases/api.models';

const routes: Routes = [
    {
        path: 'insights/profiles-per-geo',
        component: ProfilesPerGeoComponent,
        canActivate: [AuthenticationService, CanDo],
        resolve: {
            messagecentrals: MessagecentralsResolver
        },
        data : {
            canDo : [
                Permission.INSIGHTS_PROFILES_PER_GEO
            ]
        }
    },
    {
        path: 'insights/profiles-per-ip-level',
        component: ProfilesPerIpLevelComponent,
        canActivate: [AuthenticationService, CanDo],
        resolve: {
            bases: BasesResolver
        },
        data : {
            type: Base.TYPE_CHATOMATIC,
            canDo : [
                Permission.INSIGHTS_PROFILES_PER_IP_LEVEL
            ]
        }
    }
];

export const routing = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/insights/insights.routing.ts